import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular/standalone";

@Injectable({
  providedIn: "root",
})
export class ToastProvider {
  constructor(private toastCtrl: ToastController) {}

  success(message: string, duration?: number): void {
    this.show("success", message, duration);
  }

  complete(message: string): void {
    this.show("square-toast", message, 1500, "middle");
  }

  updateStandbySchedule(message: string): void {
    this.show("update-standby-schedule", message, 1500, "middle");
  }

  cancelStandbySchedule(message: string): void {
    this.show("cancel-standby-schedule", message, 1500, "middle");
  }

  achieve(message: string): void {
    this.show("rectangle-toast", message, 1500, "middle");
  }

  goodSecretEvaluation(message: string): void {
    this.show("good-secret-toast", message, 3000, "middle");
  }

  badSecretEvaluation(message: string): void {
    this.show("bad-secret-toast", message, 3000, "middle");
  }

  renameFavoriteList(message: string): void {
    this.show("rename-favorite-list", message, 3000, "middle");
  }

  tabletActionComplete(message: string): void {
    this.show("tablet-toast", message, 2000, "middle");
  }

  private async show(
    type: string,
    message: string,
    duration?: number,
    position?: "top" | "bottom" | "middle"
  ): Promise<void> {
    duration = duration || 3000;
    const toast = await this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position || "top",
      cssClass: type,
    });
    await toast.present();
  }
}
